<template>
  <div v-if="visible" class="update-modal-wrapper">
    <div class="update-modal-overlay"></div>
    <div class="update-modal-content" @click.stop>
        <div class="update-modal-text">
          This page has been updated. Please refresh to see the latest version.
        </div>
        <button class="update-modal-button" @click="handleReload">
          RELOAD
        </button>
      </div>
  </div>
</template>

<script>
export default {
  name: 'UpdateModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleReload () {
      window.location.reload(true)
    }
  }
}
</script>

<style lang="scss"  scoped>
.update-modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: $appOverlayZIndex;
}
.update-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.4;
  background: rgba(0, 0, 0, 0.16);
  backdrop-filter: blur(50px);
  z-index: $appOverlayZIndex;
}

.update-modal-content {
  position: fixed;
  top: 0;
  width: 100%;
  background: #FFF;
  border-radius: 3px;
  border: 1px solid #CACAE1;
  box-shadow: 0 8px 12px 0 rgba(30, 31, 33, 0.15);
  padding: 8px 0;
  margin: 71px 110px 0;
  max-width: calc(100vw - 220px);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  z-index: $appOverlayZIndex;
}

.update-modal-text {
  font-family: Ubuntu;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #292A2E;
}

.update-modal-button {
  font-family: Inconsolata;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px; /* 128.571% */
  letter-spacing: 0.28px;
  text-transform: uppercase;
  background: #FFF;
  color: #0052CC;
  border: none;
  padding: 12px 16px;
  border-radius: 5px;
}

.update-modal-button:hover, .update-modal-button:active {
  color: #0063F8;
  text-decoration: underline;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .update-modal-content {
    margin: 20px;
    max-width: calc(100vw - 40px);
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }

  .update-modal-button {
    width: 100%;
  }
}
</style>
